import React from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {BonusPointTransaction} from "../order_page/types";

dayjs.extend(customParseFormat);

function BonusPointsItem({bonusPoints}: {bonusPoints: BonusPointTransaction}) {

    return (
        <div
            className={"mr-5 mb-5 dark:bg-darkBox bg-textDark xl:w-5/12 w-full flex flex-col h-fit rounded-2xl "}>
            <div className={"md:p-8 p-4 dark:text-textDarkLightGray text-textLight"}>
                <div>
                    <p className="mb-4 text-sm dark:font-medium font-semibold"> №
                        <span className="dark:font-extralight font-bold ml-3">{bonusPoints?.ID}</span>
                    </p>
                    <p className="mb-4 text-sm dark:font-medium font-semibold"> Дата
                        <span className="dark:font-extralight font-normal ml-3">{bonusPoints?.TRANSACT_DATE}</span>
                    </p>
                    <p className="mb-4 text-sm dark:font-medium font-semibold"> Тип
                        <span className="dark:font-extralight font-normal ml-3">{bonusPoints?.DEBIT==='Y' ? "Приход" : "Расход"}</span>
                    </p>
                    <p className="text-sm dark:font-medium font-semibold"> Сумма
                        <span className="dark:font-extralight font-normal ml-3">{bonusPoints?.AMOUNT}</span>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default BonusPointsItem;